import { PATHS } from '@belong/common';
import { Image, Link, Text } from '@belong/ui';
import clsx from 'clsx';
import { HOME_PAGE_STRINGS } from '../../home-page.strings';
import styles from './ReferralCard.module.css';
import { REFERRALS_STRINGS } from './ReferralCard.strings';

export function ReferralCard() {
  return (
    <div
      className={clsx(
        'border-green py-2xl md:pr-sm relative flex w-full flex-col items-center overflow-hidden rounded border border-solid md:flex-row md:justify-between md:py-0',
        styles.cardContainer,
      )}
    >
      <div
        className={clsx(
          'absolute top-0 z-0 md:inset-x-0 md:top-auto',
          styles.rainBox,
        )}
      >
        <Image src="/referral/referral_money_rain_img.svg" alt="" />
      </div>
      <div className="pb-lg z-10 md:pb-0">
        <Text
          variant="h3"
          className={clsx('mb-xs whitespace-pre-line', styles.mainText)}
          fontWeight="semibold"
        >
          {REFERRALS_STRINGS['message.firstSentence']}{' '}
          <Text as="span" variant="h2" fontWeight="semibold">
            {REFERRALS_STRINGS['message.value']}
          </Text>
          <br />
          {REFERRALS_STRINGS['message.secondSentence']}
        </Text>
        <Text variant="body">{HOME_PAGE_STRINGS['referralCard.subtitle']}</Text>
      </div>
      <div className={clsx('z-10 flex items-center', styles.link)}>
        <Link
          href={PATHS.REFERRAL_LANDING}
          variant="solid"
          className="flex flex-1 items-center justify-center"
        >
          {REFERRALS_STRINGS['cta']}
        </Link>
      </div>
    </div>
  );
}
